import React from 'react'
import JobAuditions from '../fetures/job-auditions/JobAuditions'

const JobAudPage = () => {
  return (
    <JobAuditions/>
  )
}

export default JobAudPage
